module.exports = ".pages-content {\r\n  padding-top: 0;\r\n}\r\n\r\n.pages-content h3 {\r\n  margin: 10px 0;\r\n}\r\n\r\n.workout-form,\r\n.workout-view {\r\n  padding: 20px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/team-injuries/team-player-injuries/team-player-injuries.component.css
// module id = ./src/app/pages/team-injuries/team-player-injuries/team-player-injuries.component.css
// module chunks = main